export default __webpack_public_path__ + "6be0a126b485f90a907822c0e671c9ef.png";